import React from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import LoadingLoginScreen from '../LoadingLoginScreen'

import { getLeadSessionID } from "../../services/Leadservice";
import { getPandaDocSessionID } from "../../services/PandaDocService";
import './modalstyle.css'

export const EmbedQuote = ({ pandadocid, fsdocID, email }, props) => {
    const [show, setShow] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [sessionID, setSessionID] = React.useState("");


    const fetchSessionId = React.useCallback(async () => {

        try {
            setLoading(true);
            await getPandaDocSessionID(fsdocID, pandadocid, email)
            const value = await getLeadSessionID(fsdocID);

            setSessionID(value);
            setLoading(false);


        } catch {

        }

    }, []);


    React.useEffect(() => {
        const val = fetchSessionId();


    }, [])

    return (
        <>
            <Button onClick={() => setShow(!show)}>
                Visa offert/Ladda ner offert
            </Button>

            <Modal
                show={show}
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Header>
                    {error ? <Alert variant="warning">{errorText} </Alert> : null}
                    Visar offert för {email}
                </Modal.Header>
                <Modal.Body
                    className={"custom-modal-style"}

                >

                    {loading ?
                        <LoadingLoginScreen />
                        :

                        <iframe
                            height="650" width="600"
                            src={`https://app.pandadoc.com/s/${sessionID}`} />

                    }


                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShow(false)}>
                        Stäng
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
